import React, { useEffect, useState } from "react";
import { Icons } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import { useNotifications } from "../../contexts/NotificationProvider";
import styled from "styled-components";
import ItemActions from "./ItemActions";
// import Switch from "./Switch";
import TimeTracker from "./TimeTracker";

const variants = {
  container: {
    open: { y: 0, opacity: 1 },
    closed: { y: -10, opacity: 0 },
  },
  content: {
    open: { transition: { staggerChildren: 0.07, delayChildren: 0.2 } },
    closed: { transition: { staggerChildren: 0.05, staggerDirection: -1 } },
  },
  item: {
    open: {
      y: 0,
      opacity: 1,
      transition: { y: { stiffness: 1000, velocity: -100 } },
    },
    closed: { y: 50, opacity: 0, transition: { y: { stiffness: 1000 } } },
  },
};

// const UnreadFilter = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;

//   label {
//     cursor: pointer;
//   }
// `;

const Container = styled(motion.aside)`
  //   width: min(60ch, 100%);
  //   min-width: 400px;
  border-radius: 8px;
  overflow: hidden;
  @media (max-width: 768px) {
    min-width: unset;
  }
`;

const Content = styled(motion.section)`
  background: #fff;
  height: 100%;
  overflow-y: auto;
  color: #6c757d;
  padding: 1rem;
  position: relative;

  h4 {
    margin: 0;
    text-align: center;
    padding: 2rem;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const Footer = styled.footer`
  background: #eb6f33;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    // flex-direction: column;
    align-items: flex-start;
  }
`;

const IconWrapper = styled.div`
  width: 32px;
`;

const Item = styled(motion.article)`
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  gap: 8px;
  padding: 0.8rem;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

const Header = styled.header`
  background: #EB6F33;
  color: #ffffff;
  margin: 0;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  //   @media (max-width: 768px) {
  //     flex-direction: column;
  //   }
`;

const NotificationCenter = () => {
  const {
    notifications,
    clearAll,
    markAllAsRead,
    markAsRead: markSingleAsRead, // Renaming to avoid confusion
    remove,
    unreadCount,
  } = useNotifications(); // Consume notifications from the context
  const [showUnreadOnly, toggleFilter] = useState(false);
  //   const [isOpen, setIsOpen] = useState(false);
  const colorToIcon = {
    info: Icons.info,
    success: Icons.success,
    error: Icons.error, // 'danger' should map to 'error' in Toastify
    warning: Icons.warning,
  };
  // console.log("notifications", notifications);
  useEffect(() => {
    const popoverElements = document.querySelectorAll(
      '[data-bs-toggle="popover"]'
    );
    // popoverElements.forEach((popover) => {
    //   new window.bootstrap.Popover(popover); // Initialize Bootstrap popover
    // });
    const popovers = Array.from(popoverElements).map(
      (el) => new window.bootstrap.Popover(el)
    );

    // Cleanup function to destroy popovers
    return () => {
      popovers.forEach((popover) => popover.dispose());
    };
  }, [notifications]);
  return (
    <div>
      {/* <Trigger onClick={() => setIsOpen(!isOpen)} count={unreadCount} /> */}
      <Container initial={false} variants={variants.container}>
        <Header>
          <h5 className="fw-bold mt-2">{"Import File Notification(s)"}</h5>
          {/* <UnreadFilter>
            <label
              htmlFor="unread-filter"
              style={{ fontSize: "10px", fontWeight: "700" }}
            >
              Only show unread
            </label>
            <Switch
              id="unread-filter"
              checked={showUnreadOnly}
              onChange={() => toggleFilter(!showUnreadOnly)}
            />
          </UnreadFilter> */}
        </Header>
        <AnimatePresence>
          <Content
            variants={variants.content}
            // animate={isOpen ? "open" : "closed"}
          >
            {(!notifications.length ||
              (unreadCount === 0 && showUnreadOnly)) && (
              <motion.h6
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <p className="mb-0" style={{ fontSize: "medium" }}>
                  {" "}
                  {"No notification(s) yet! "}
                </p>
                <span
                  role="img"
                  aria-label="emoji"
                  style={{ fontSize: "x-large" }}
                >
                  🧐
                </span>
              </motion.h6>
            )}
            <AnimatePresence>
              {(showUnreadOnly
                ? notifications.filter((v) => !v.read)
                : notifications
              ).map((notification) => {
                //   const popoverContent = notification.messages.join('<br />');
                const popoverContent =
                  notification?.result === false &&
                  notification.state === "failed"
                    ? "Error while creating vatiants!"
                    : notification?.result;
                // console.log(
                //   "popoverContent and state",
                //   popoverContent,
                //   notification.state
                // );
                let cleaned = false;
                if (popoverContent) {
                  // Step 1: Remove `'ids': False,`
                  const withoutIds = popoverContent.replace(
                    /'ids': False,\s*/,
                    ""
                  );
                  // Step 2: Remove "Unknown error during import: <class 'odoo.exceptions.ValidationError'>:"
                  cleaned = withoutIds
                    .replace(
                      /Unknown error during import: <class 'odoo.exceptions.ValidationError'>:/g,
                      ""
                    )
                    .trim();
                  //   console.log("cleaned PopOver content", cleaned);
                }
                return (
                  <motion.div
                    key={notification.id}
                    layout
                    initial={{ scale: 0.4, opacity: 0, y: 50 }}
                    exit={{
                      scale: 0,
                      opacity: 0,
                      transition: { duration: 0.2 },
                    }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    style={{ padding: "0.8rem" }}
                  >
                    <Item key={notification.id} variants={variants.item}>
                      <IconWrapper>
                        {notification.icon ||
                          (colorToIcon[notification.color]
                            ? colorToIcon[notification.color]({
                                theme: "light",
                                type: notification.color, // Using the notification color for type
                              })
                            : Icons.info({
                                theme: "light",
                                type: "info", // Default to 'info' if the color doesn't match
                              }))}
                      </IconWrapper>
                      <div className="d-flex flex-column align-items-start justify-content-center">
                        <div>{notification.name}</div>
                        <div className="d-flex align-item-center justify-content-between gap-3">
                          <TimeTracker createdAt={notification.date} />
                          {notification.state === "failed" && (
                            <a
                              type="button"
                              id={notification.id}
                              className="text-danger text-decoration-none cursor-pointer fw-bold mt-1"
                              data-bs-toggle="popover"
                              data-bs-title="Error Details"
                              data-bs-content={cleaned} // Dynamic popover content
                              data-bs-trigger="hover focus" // Optional: Trigger popover on hover or focus
                              style={{ fontSize: "small" }}
                            >
                              View Error Details
                            </a>
                          )}
                        </div>
                      </div>
                      <ItemActions
                        notification={notification}
                        markAsRead={() => markSingleAsRead(notification.id)}
                        remove={() => remove(notification.id)}
                      />
                    </Item>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </Content>
        </AnimatePresence>
        {notifications.length > 0 && (
          <Footer>
            <button
              onClick={clearAll}
              className="btn"
              style={{
                background: "#fff",
                color: "#ff5837",
                borderRadius: "10px",
                borderColor: "#ff5837",
                outline: "0",
              }}
            >
              Clear All
            </button>
            <button
              onClick={markAllAsRead}
              className="btn"
              style={{
                background: "#fff",
                color: "#ff5837",
                borderRadius: "10px",
                borderColor: "#ff5837",
                outline: "0",
              }}
            >
              Mark All as Read
            </button>
          </Footer>
        )}
      </Container>
    </div>
  );
};

export default NotificationCenter;
